// src/components/ItemsTable.js
import React from "react";

const ItemsTable = ({ items }) => {
  return (
    <div className="bg-white dark:bg-gray-800 shadow rounded p-6 mb-6 overflow-x-auto border border-gray-100 dark:border-gray-700 transition-colors duration-300">
      <h2 className="text-xl font-semibold text-gray-800 dark:text-gray-100 mb-4">
        Items
      </h2>

      {items && items.length > 0 ? (
        <table className="w-full border-collapse text-sm text-gray-800 dark:text-gray-200 transition-colors duration-300">
          <thead className="bg-gray-50 dark:bg-gray-700/60 text-gray-700 dark:text-gray-200">
            <tr>
              <th className="border-b border-gray-200 dark:border-gray-600 py-2 text-left px-2">
                Description
              </th>
              <th className="border-b border-gray-200 dark:border-gray-600 py-2 text-center px-2">
                Unit
              </th>
              <th className="border-b border-gray-200 dark:border-gray-600 py-2 text-right px-2">
                Unit Price
              </th>
              <th className="border-b border-gray-200 dark:border-gray-600 py-2 text-right px-2">
                Amount
              </th>
            </tr>
          </thead>

          <tbody>
            {items.map((item, i) => (
              <tr
                key={i}
                className="hover:bg-gray-50 dark:hover:bg-gray-700/50 transition-colors duration-200"
              >
                <td className="py-2 px-2 whitespace-pre-line border-b border-gray-100 dark:border-gray-700">
                  {item.description || "-"}
                </td>
                <td className="py-2 px-2 text-center border-b border-gray-100 dark:border-gray-700">
                  {item.unit || "-"}
                </td>
                <td className="py-2 px-2 text-right border-b border-gray-100 dark:border-gray-700">
                  {item.unitPrice
                    ? parseFloat(item.unitPrice).toLocaleString("th-TH", {
                        style: "currency",
                        currency: "THB",
                      })
                    : "-"}
                </td>
                <td className="py-2 px-2 text-right border-b border-gray-100 dark:border-gray-700">
                  {item.amount
                    ? item.amount.toLocaleString("th-TH", {
                        style: "currency",
                        currency: "THB",
                      })
                    : "-"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p className="text-gray-500 dark:text-gray-400 transition-colors duration-300">
          No items available.
        </p>
      )}
    </div>
  );
};

export default ItemsTable;
